import { render } from "./LinkGroup.vue?vue&type=template&id=982fecc6&scoped=true&ts=true"
import script from "./LinkGroup.vue?vue&type=script&lang=ts"
export * from "./LinkGroup.vue?vue&type=script&lang=ts"

import "./LinkGroup.vue?vue&type=style&index=0&id=982fecc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-982fecc6"]])

export default __exports__